import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ExternalService, ICountry, IDanishCompanyIndex, IFoundZip, ZipcodeService } from 'src/app/xena-api';

@Component({
    selector: 'app-step1-company',
    templateUrl: './step1-company.component.html',
    styleUrls: ['./step1-company.component.scss'],
    standalone: false
})
export class Step1CompanyComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  @Input() form: UntypedFormGroup;
  @Input() countries: ICountry[];

  constructor(
    private zipcodeService: ZipcodeService,
    private externalService: ExternalService
  ) { }

  ngOnInit(): void {
    this.subscriptions = [
      this.form.get('address.zip').valueChanges.subscribe(() => this.setCity()),
      this.form.get('address.countryName').valueChanges.subscribe(() => this.setCity()),
      this.form.get('address.countryName').valueChanges.subscribe(() => this.countryOnChange()),
      this.form.get('danishCompany').valueChanges.subscribe(() => this.danishCompanyOnChange())
    ];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  companiesDatasource = (queryString: string): Promise<IDanishCompanyIndex[]> => {
    return this.externalService.getDanishCompanyByCVRList({ queryString, forceNoPaging: false })
      .pipe(map(x => x.entities))
      .toPromise();
  }

  companyLabel(c: IDanishCompanyIndex): string {
    return `${c.cVRNumber} ${c.companyName}`;
  };

  setCity(): void {
    const countryCode = this.form.get('address.countryName').value;
    const zipcode = this.form.get('address.zip').value;

    if (!countryCode || !zipcode) return;

    this.zipcodeService.get(countryCode + zipcode).subscribe((zipcode: IFoundZip) => {
      if (zipcode.city) {
        this.form.get('address.city').setValue(zipcode.city);
      }
    });
  }

  countryOnChange(): void {
    const countryCode = this.form.get('address.countryName').value;
    if (countryCode !== "DK") {
      this.form.get('orgNumber').setValue('');
      this.form.get('danishCompany').setValue(null);
    }
    this.form.get('orgNumber').markAsPristine();
    this.form.get('danishCompany').markAsPristine();
  }

  danishCompanyOnChange(): void {
    const company = this.form.get('danishCompany').value as IDanishCompanyIndex;
    if (!!company) {
      this.form.patchValue({
        orgNumber: company.cVRNumber,
        address: {
          name: company.companyName,
          street: company.street,
          placeName: company.placeName,
          city: company.city,
          zip: company.zip,
          countryName: 'DK'
        },
        email: company.email ?? '',
        phone: company.phone ?? ''
      });
    } else {
      this.form.patchValue({
        orgNumber: ''
      });
    }
    this.form.markAsPristine();
  }
}
